import { useTranslation } from 'react-i18next';
import 'react-step-progress-bar/styles.css';
import { ProgressBar, Step } from 'react-step-progress-bar';
import ProgressBarStep from './components/ProgressBarStep';

export enum TransactionSteps {
  TRANSFER = 0,
  SELL = 49,
  WITHDRAW = 99,
  COMPLETED = 100,
}

const TransactionProgressBar = ({
  step = TransactionSteps.TRANSFER,
}: {
  step?: TransactionSteps;
}) => {
  const { t } = useTranslation();

  return (
    <div className="w-full px-5 mt-3 h-10">
      <ProgressBar height={5} filledBackground="#4caf50" percent={step}>
        <Step transition="scale">
          {() => (
            <ProgressBarStep
              isAccomplished={step > TransactionSteps.TRANSFER}
              text={t('components.transactions.transfer')}
            />
          )}
        </Step>
        <Step transition="scale">
          {() => (
            <ProgressBarStep
              isAccomplished={step > TransactionSteps.SELL}
              text={t('common.sell')}
            />
          )}
        </Step>
        <Step transition="scale">
          {() => (
            <ProgressBarStep
              isAccomplished={step > TransactionSteps.WITHDRAW}
              text={t('pages.accounts.admin.withdrawals.withdraw')}
            />
          )}
        </Step>
      </ProgressBar>
    </div>
  );
};

export default TransactionProgressBar;
